/* Ma Robe de Chambre — fiche produit : variantes, Achat simple / Club, Garantie+, pochette, ajout au panier,
   dates de livraison, barre d'achat collante (mobile). La page se charge au prix normal. */
(() => {
  const root = document.querySelector('[data-m-pdp]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-m-pdata]').textContent);
  const form = root.querySelector('[data-m-pform]');
  const q = (s) => root.querySelector(s);
  const qa = (s) => [...root.querySelectorAll(s)];
  const nbsp = ' ';
  const fmt = (c) => (c / 100).toFixed(2).replace('.', ',') + nbsp + '€';
  const routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fieldsets = qa('[data-m-opt]');
  const vidInput = form.querySelector('[data-m-vid]');
  let current = data.variants.find((v) => String(v.id) === vidInput.value) || data.variants[0];
  let plan = 'simple';

  const selection = () => fieldsets.map((f) => {
    const i = f.querySelector('input:checked');
    return i ? i.value : null;
  });
  const findVariant = (sel) => data.variants.find((v) => v.options.every((o, i) => sel[i] == null || o === sel[i]));
  const code = (value) => String(value || '').split(' (')[0];
  const clubPrice = (cents) => Math.round(cents * (100 - data.club.pct) / 100);
  const priceNow = () => (plan === 'club' ? clubPrice(current.price) : current.price);

  /* poids et longueur conseillés : guide des tailles, sinon libellé « M (40-65kg) » */
  const sizeInfo = (v) => {
    if (data.sizeIndex < 0) return '';
    const raw = v.options[data.sizeIndex];
    const row = data.sizes.find((r) => r.t === code(raw) || r.t === raw);
    let weight = row && row.w;
    if (!weight) {
      const m = raw.match(/\(([^)]+)\)/);
      if (m) weight = m[1].replace(/\s*-\s*/, ' à ').replace(/kg/i, nbsp + 'kg').replace(/\s+kg/i, nbsp + 'kg');
    }
    const parts = [];
    if (weight) parts.push('Poids conseillé <strong>' + weight + '</strong>');
    if (row && row.l) parts.push('Longueur ' + row.l);
    return parts.join(' · ');
  };

  /* tailles et coloris indisponibles avec la sélection en cours */
  const markAvailability = () => {
    const sel = selection();
    fieldsets.forEach((f, i) => {
      f.querySelectorAll('input').forEach((input) => {
        const test = sel.slice();
        test[i] = input.value;
        const v = findVariant(test);
        const ok = !!(v && v.available);
        const label = f.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-off', !ok);
        if (Number(f.dataset.mOpt) === data.sizeIndex) input.disabled = !ok && !input.checked;
      });
    });
  };

  const garantieVariant = (cents) => {
    const vs = data.garantie.variants;
    if (!vs.length) return null;
    const idx = Math.min(data.garantie.bounds.filter((b) => cents > b).length, vs.length - 1);
    return vs[idx];
  };

  const render = () => {
    vidInput.value = current.id;
    const now = priceNow();
    const price = q('[data-m-price]');
    if (price) price.textContent = fmt(now);
    const was = q('[data-m-compare]');
    if (was) {
      /* prix barré de référence conservé avec le Club ; sans prix barré, le Club barre le prix de l'achat simple */
      const ref = current.compare > current.price ? current.compare : (plan === 'club' ? current.price : 0);
      was.hidden = !(ref > now);
      /* prix barré rond : « 163 € » plutôt que « 163,00 € » */
      if (ref > now) was.textContent = ref % 100 === 0 ? ref / 100 + nbsp + '€' : fmt(ref);
      /* Black Month : étiquette de remise, arrondie comme sur les cartes */
      /* Black Month : étiquette de la remise du prix barré, puis « + -10 % » à côté si le Club est choisi */
      const off = q('[data-m-off]');
      if (off) {
        const sale = current.compare > current.price;
        off.hidden = was.hidden;
        if (!was.hidden) off.textContent = '-' + Math.round((ref - (sale ? current.price : now)) * 100 / ref) + nbsp + '%';
        qa('[data-m-off-club]').forEach((el) => { el.hidden = !(sale && plan === 'club'); });
      }
    }
    const kl = q('[data-m-klarna]');
    if (kl) kl.textContent = 'ou 3 × ' + fmt(Math.round(now / 3));
    const ps = q('[data-m-plan-simple]');
    if (ps) ps.textContent = fmt(current.price);
    const pw = q('[data-m-plan-was]');
    if (pw) {
      pw.hidden = !(current.compare > current.price);
      if (!pw.hidden) pw.lastChild.textContent = current.compare % 100 === 0 ? current.compare / 100 + nbsp + '€' : fmt(current.compare);
    }
    const pc = q('[data-m-plan-club]');
    if (pc) pc.textContent = fmt(clubPrice(current.price));

    /* même base que le panier : prix après la remise du Club */
    const g = garantieVariant(now);
    const gInput = q('[data-m-gplus-input]');
    if (g && gInput) {
      gInput.value = g.id;
      const gp = q('[data-m-gplus-price]');
      if (gp) gp.textContent = fmt(g.price);
    }
    /* le bouton annonce ce qui part au panier : robe + Garantie+ si elle est cochée */
    const total = now + (g && gInput && gInput.checked ? g.price : 0);

    const atc = q('[data-m-atc]');
    const atcLabel = q('[data-m-atc-label]');
    atc.disabled = !current.available;
    atcLabel.textContent = current.available ? 'Ajouter au panier · ' + fmt(total) : 'Épuisé';

    const size = data.sizeIndex >= 0 ? code(current.options[data.sizeIndex]) : '';
    const stock = q('[data-m-stock]');
    if (stock) {
      stock.innerHTML = current.available
        ? '<i aria-hidden="true"></i>En stock' + (size ? ' en ' + size : '') + ', expédiée sous ' + data.ship.dispatch
        : '<i class="is-off" aria-hidden="true"></i>Momentanément épuisé';
    }
    const info = q('[data-m-size-info]');
    if (info) info.innerHTML = sizeInfo(current);
    const colorLabel = q('.m-opt--color [data-m-opt-label]');
    if (colorLabel && data.colorIndex >= 0) colorLabel.textContent = current.options[data.colorIndex];

    const giftTitle = q('[data-m-gift-title]');
    if (giftTitle) {
      giftTitle.innerHTML = now >= data.pouch.threshold
        ? 'Offert' + nbsp + ':'
        : 'Offert dès ' + (data.pouch.threshold / 100) + nbsp + '€' + nbsp + ':';
    }
    const sp = q('[data-m-sticky-price]');
    if (sp) sp.textContent = fmt(total);
    const ss = q('[data-m-sticky-size]');
    if (ss) ss.textContent = size ? 'Taille ' + size : '';

    markAvailability();
  };

  const gBox = q('[data-m-gplus-input]');
  if (gBox) gBox.addEventListener('change', render);

  fieldsets.forEach((f, i) => f.addEventListener('change', () => {
    const sel = selection();
    let v = findVariant(sel);
    if (!v || !v.available) {
      /* coloris changé : on garde la taille si elle existe, sinon la première disponible */
      const same = data.variants.filter((x) => x.options[i] === sel[i]);
      v = same.find((x) => x.available) || same[0] || v;
      if (v) {
        fieldsets.forEach((ff, k) => {
          const inp = [...ff.querySelectorAll('input')].find((x) => x.value === v.options[k]);
          if (inp) inp.checked = true;
        });
      }
    }
    if (!v) return;
    const prevImage = current.image;
    current = v;
    const url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState({}, '', url);
    /* photo de la variante : seul le carrousel mobile glisse, la page ne bouge jamais (sur PC, grille fixe) */
    const gal = q('.m-gal');
    const fig = v.image > 0 && v.image !== prevImage ? qa('.m-gal__i')[v.image - 1] : null;
    if (gal && fig && gal.scrollWidth > gal.clientWidth + 2) {
      const left = fig.getBoundingClientRect().left - gal.getBoundingClientRect().left + gal.scrollLeft;
      if (Math.abs(left - gal.scrollLeft) > 2) gal.scrollTo({ left, behavior: 'smooth' });
    }
    render();
  }));

  qa('[data-m-plan]').forEach((r) => r.addEventListener('change', () => {
    plan = r.value;
    render();
  }));

  /* ajout au panier : robe + Garantie+ en une requête, puis code du Club appliqué par Shopify */
  const post = async (path, body) => {
    const res = await fetch(routes + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Ajout impossible');
    return json;
  };
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const atc = q('[data-m-atc]');
    const err = q('[data-m-atc-err]');
    if (!current.available || atc.getAttribute('aria-busy') === 'true') return;
    /* personnalisation : champs obligatoires et longueur maximale, puis propriétés de la ligne */
    const props = {};
    const fields = qa('[data-m-prop]');
    if (!fields.every((f) => f.reportValidity())) return;
    fields.forEach((f) => { if (f.value.trim()) props[f.name.slice(11, -1)] = f.value.trim(); });
    atc.setAttribute('aria-busy', 'true');
    err.hidden = true;
    const cart = window.MRDC && window.MRDC.cart;
    const opened = cart && cart.openBusy ? cart.openBusy() : false;
    try {
      const items = [{ id: current.id, quantity: 1, properties: props }];
      const gInput = q('[data-m-gplus-input]');
      if (gInput && gInput.checked) items.push({ id: Number(gInput.value), quantity: 1, properties: { _mrdc: 'garantie' } });
      const withClub = plan === 'club' && data.club.code;
      /* rendu groupé : la réponse contient déjà le HTML du panier (une requête de moins) */
      const sections = { sections: 'mrdc-cart', sections_url: window.location.pathname };
      const res = await post('cart/add.js', withClub ? { items } : { items, ...sections });
      let html = res.sections && res.sections['mrdc-cart'];
      if (withClub) {
        try { const up = await post('cart/update.js', { discount: data.club.code, ...sections }); html = up.sections && up.sections['mrdc-cart']; } catch (e2) { /* le panier propose encore « Activer » */ }
      }
      if (html && cart && cart.paint) cart.paint(html);
      const line = res.items && res.items[0];
      if (window.SeoShopifyTracking && typeof window.SeoShopifyTracking.handleAddToCartSuccess === 'function') {
        window.SeoShopifyTracking.handleAddToCartSuccess(form, line);
      } else {
        document.dispatchEvent(new CustomEvent('updateCart', { detail: { lineItem: line }, bubbles: true }));
      }
    } catch (ex) {
      if (opened && cart) { cart.close(); }
      err.textContent = ex.message;
      err.hidden = false;
    } finally {
      atc.removeAttribute('aria-busy');
      /* panier actif dès qu'il est repeint ; sans rendu dans la réponse, l'événement updateCart le recharge */
      if (cart && cart.idle && cart.fresh) cart.idle();
    }
  });

  /* dates de livraison en jours ouvrés (lundi au vendredi), à l'heure de Paris : une commande passée
     avant l'heure limite un jour ouvré compte ce jour-là comme premier jour, sinon on part du jour ouvré suivant */
  const isOpen = (d) => d.getDay() !== 0 && d.getDay() !== 6;
  const addBusinessDays = (d, n) => {
    const r = new Date(d);
    let left = n;
    while (left > 0) {
      r.setDate(r.getDate() + 1);
      if (isOpen(r)) left -= 1;
    }
    return r;
  };
  const day = (d) => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }).replace(' ', nbsp);
  const paris = {};
  new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
    .formatToParts(new Date()).forEach((p) => { paris[p.type] = +p.value; });
  const start = new Date(paris.year, paris.month - 1, paris.day);
  if (isOpen(start) && paris.hour < (data.ship.cutoff ?? 8)) start.setDate(start.getDate() - 1);
  const from = day(addBusinessDays(start, data.ship.min));
  const to = day(addBusinessDays(start, data.ship.max));
  const eta = q('[data-m-eta]');
  if (eta) eta.innerHTML = 'Livrée gratuitement entre le <strong>' + from + '</strong> et le <strong>' + to + '</strong>';
  const etaShort = q('[data-m-eta-short]');
  if (etaShort) etaShort.textContent = from + ' – ' + to;

  /* barre d'achat collante (mobile) : visible seulement quand le vrai bouton ne l'est plus */
  const sticky = q('[data-m-sticky]');
  const stickyBtn = q('[data-m-sticky-btn]');
  const atcBtn = q('[data-m-atc]');
  if (sticky && atcBtn) {
    /* au défilement plutôt qu'avec IntersectionObserver : un saut (ancre, retour, défilement rapide)
       peut passer le bouton sans jamais le croiser */
    let ticking = false;
    const sync = () => {
      ticking = false;
      /* comme la maquette : la barre s'affiche dès que le vrai bouton n'est pas à l'écran */
      const r = atcBtn.getBoundingClientRect();
      const hidden = r.bottom > 0 && r.top < window.innerHeight;
      sticky.classList.toggle('is-on', !hidden);
      sticky.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      stickyBtn.tabIndex = hidden ? -1 : 0;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sync();
    stickyBtn.addEventListener('click', () => form.requestSubmit());
  }

  /* « Lire la description complète » : déplie la section Description longue */
  qa('[data-m-open-desc]').forEach((a) => a.addEventListener('click', () => {
    const btn = document.querySelector('#description [data-m-fold-btn]');
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  }));

  render();
})();

/* « Vous aimerez aussi » : flèches et barre de progression du carrousel */
(() => {
  document.querySelectorAll('[data-m-rel]').forEach((box) => {
    const track = box.querySelector('[data-m-rel-track]');
    const bar = box.querySelector('[data-m-rel-bar]');
    const prev = box.querySelector('[data-m-rel-prev]');
    const next = box.querySelector('[data-m-rel-next]');
    if (!track) return;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      /* barre remplie à proportion de ce qui a déjà été vu */
      if (bar) bar.style.width = Math.min(1, (track.clientWidth + track.scrollLeft) / track.scrollWidth) * 100 + '%';
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    const step = (dir) => {
      const item = track.firstElementChild;
      const w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();

/* Bénéfices : fixes s'ils tiennent dans la largeur, sinon bandeau qui défile lentement (contenu dupliqué pour une boucle sans saut) */
(() => {
  document.querySelectorAll('[data-m-ben]').forEach((box) => {
    const track = box.querySelector('.m-ben__track');
    const list = track && track.querySelector('.m-ben__list');
    if (!list) return;
    let clone = null;
    const check = () => {
      box.classList.remove('is-marquee');
      if (clone) { clone.remove(); clone = null; }
      if (list.scrollWidth <= box.clientWidth + 1) return;
      clone = list.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      box.classList.add('is-marquee');
      /* environ 22 px par seconde, quelle que soit la longueur : lisible */
      box.style.setProperty('--m-ben-dur', Math.max(12, Math.round(list.scrollWidth / 22)) + 's');
    };
    check();
    if ('ResizeObserver' in window) {
      let w = box.clientWidth;
      new ResizeObserver(() => { if (Math.abs(box.clientWidth - w) > 1) { w = box.clientWidth; check(); } }).observe(box);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  });
})();

/* Visionneuse des photos, en carrousel plein écran.
   - ouverture instantanée : chaque diapo affiche d'abord la photo déjà chargée par la galerie, la version haute
     définition la remplace dès qu'elle est prête (photo courante et voisines préchargées) ;
   - glisser : la photo suit le doigt et se cale sur la suivante ou la précédente ;
   - zoom : double clic (souris) ou double tap (tactile), molette, pincement ; photo zoomée déplaçable ;
   - flèches, Échap ou × pour fermer. */
(() => {
  const figs = Array.from(document.querySelectorAll('[data-m-zoom]'));
  if (!figs.length) return;
  const MAX = 4, SNAP = 0.18;
  let dlg, stage, track, slides = [], count, idx = 0, scale = 1, tx = 0, ty = 0;
  const pts = new Map();
  let pinch = null, drag = null, lastTap = { t: 0, x: 0, y: 0 };
  const icon = (d) => '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + d + '"/></svg>';
  const img = () => slides[idx].img;

  /* haute définition chargée en arrière-plan puis substituée sans clignotement */
  const upgrade = (i) => {
    const s = slides[i];
    if (!s || s.hd) return;
    s.hd = true;
    const pre = new Image();
    pre.decoding = 'async';
    pre.onload = () => { s.img.src = pre.src; };
    pre.src = figs[i].dataset.mZoom;
  };
  const place = (animate, offset) => {
    track.style.transition = animate ? 'transform .28s cubic-bezier(.2,.7,.2,1)' : 'none';
    track.style.transform = 'translate3d(calc(' + (-idx * 100) + '% + ' + (offset || 0) + 'px), 0, 0)';
  };
  const apply = () => {
    const el = img(), r = stage.getBoundingClientRect();
    const mx = Math.max(0, (el.offsetWidth * scale - r.width) / 2), my = Math.max(0, (el.offsetHeight * scale - r.height) / 2);
    tx = Math.min(mx, Math.max(-mx, tx));
    ty = Math.min(my, Math.max(-my, ty));
    el.style.transform = scale > 1 ? 'translate3d(' + tx + 'px, ' + ty + 'px, 0) scale(' + scale + ')' : '';
    dlg.classList.toggle('is-zoomed', scale > 1);
  };
  const zoomAt = (next, cx, cy, smooth) => {
    next = Math.min(MAX, Math.max(1, next));
    const r = stage.getBoundingClientRect();
    const ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
    tx = ox - (ox - tx) * (next / scale);
    ty = oy - (oy - ty) * (next / scale);
    scale = next;
    if (scale === 1) { tx = 0; ty = 0; }
    img().style.transition = smooth ? 'transform .22s ease-out' : 'none';
    apply();
  };
  const toggleZoom = (cx, cy) => zoomAt(scale > 1 ? 1 : 2.5, cx, cy, true);
  const resetZoom = () => {
    if (!slides[idx]) return;
    scale = 1; tx = 0; ty = 0;
    img().style.transform = '';
    dlg.classList.remove('is-zoomed');
  };
  const show = (i, animate) => {
    resetZoom();
    idx = Math.min(figs.length - 1, Math.max(0, i));
    place(animate);
    count.textContent = figs.length > 1 ? (idx + 1) + ' / ' + figs.length : '';
    upgrade(idx); upgrade(idx + 1); upgrade(idx - 1);
  };

  const down = (e) => {
    if (e.target.closest('button')) return;
    stage.setPointerCapture(e.pointerId);
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 2) {
      const [a, b] = [...pts.values()];
      pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: scale, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 };
      drag = null;
      place(true);
      return;
    }
    drag = { x: e.clientX, y: e.clientY, t: performance.now(), tx: tx, ty: ty, moved: false, bg: !e.target.closest('img') };
    if (e.pointerType !== 'mouse') {
      const now = performance.now();
      if (now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 40) {
        toggleZoom(e.clientX, e.clientY);
        drag = null;
        lastTap.t = 0;
      } else lastTap = { t: now, x: e.clientX, y: e.clientY };
    }
  };
  const move = (e) => {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pinch && pts.size === 2) {
      const [a, b] = [...pts.values()];
      zoomAt(pinch.s * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d, pinch.cx, pinch.cy, false);
      return;
    }
    if (!drag) return;
    const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 5) drag.moved = true;
    if (scale > 1) { tx = drag.tx + dx; ty = drag.ty + dy; img().style.transition = 'none'; apply(); }
    else if (figs.length > 1) {
      /* résistance aux extrémités */
      const edge = (idx === 0 && dx > 0) || (idx === figs.length - 1 && dx < 0);
      place(false, edge ? dx * 0.3 : dx);
    }
  };
  const up = (e) => {
    pts.delete(e.pointerId);
    if (pts.size < 2) pinch = null;
    if (drag && scale === 1) {
      const dx = e.clientX - drag.x, w = stage.clientWidth;
      const fast = Math.abs(dx) / Math.max(1, performance.now() - drag.t) > 0.5;
      if (drag.moved && (Math.abs(dx) > w * SNAP || (fast && Math.abs(dx) > 30))) show(idx + (dx < 0 ? 1 : -1), true);
      else if (drag.moved) place(true);
      else if (drag.bg && e.pointerType === 'mouse') dlg.close();
    }
    if (!pts.size) drag = null;
  };

  const build = () => {
    dlg = document.createElement('dialog');
    dlg.className = 'm-lb';
    dlg.setAttribute('aria-label', 'Photos du produit en grand');
    dlg.innerHTML = '<div class="m-lb__stage"><div class="m-lb__track"></div></div>'
      + '<button type="button" class="m-lb__x" aria-label="Fermer">' + icon('M6 6l12 12M18 6L6 18') + '</button>'
      + (figs.length > 1
        ? '<button type="button" class="m-lb__nav m-lb__nav--p" aria-label="Photo précédente">' + icon('M15 5l-7 7 7 7') + '</button>'
          + '<button type="button" class="m-lb__nav m-lb__nav--n" aria-label="Photo suivante">' + icon('M9 5l7 7-7 7') + '</button>'
        : '')
      + '<p class="m-lb__count" aria-live="polite"></p><p class="m-lb__hint">Double-cliquez ou pincez pour zoomer</p>';
    document.body.appendChild(dlg);
    stage = dlg.querySelector('.m-lb__stage');
    track = dlg.querySelector('.m-lb__track');
    count = dlg.querySelector('.m-lb__count');
    slides = figs.map((f) => {
      const slide = document.createElement('div');
      slide.className = 'm-lb__slide';
      const im = document.createElement('img');
      const thumb = f.querySelector('img');
      im.src = (thumb && (thumb.currentSrc || thumb.src)) || f.dataset.mZoom;
      im.alt = f.dataset.mZoomAlt || '';
      im.draggable = false;
      im.decoding = 'async';
      slide.appendChild(im);
      track.appendChild(slide);
      return { img: im, hd: false };
    });
    dlg.querySelector('.m-lb__x').addEventListener('click', () => dlg.close());
    const prev = dlg.querySelector('.m-lb__nav--p'), next = dlg.querySelector('.m-lb__nav--n');
    if (prev) prev.addEventListener('click', () => show(idx - 1, true));
    if (next) next.addEventListener('click', () => show(idx + 1, true));
    dlg.addEventListener('close', () => { resetZoom(); document.documentElement.classList.remove('m-lb-open'); });
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(idx - 1, true);
      if (e.key === 'ArrowRight') show(idx + 1, true);
    });
    stage.addEventListener('wheel', (e) => { e.preventDefault(); zoomAt(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY, false); }, { passive: false });
    /* double clic souris uniquement : le double tap tactile est géré dans pointerdown (sinon les deux s'annulent) */
    let lastType = 'mouse';
    stage.addEventListener('pointerdown', (e) => { lastType = e.pointerType; }, true);
    stage.addEventListener('dblclick', (e) => { if (lastType === 'mouse') toggleZoom(e.clientX, e.clientY); });
    stage.addEventListener('pointerdown', down);
    stage.addEventListener('pointermove', move);
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
  };

  /* la photo haute définition de la première diapo commence à charger dès le survol ou l'appui */
  const warm = (i) => { if (!dlg) build(); upgrade(i); };
  figs.forEach((f, i) => {
    f.classList.add('is-zoomable');
    f.setAttribute('role', 'button');
    f.setAttribute('tabindex', '0');
    f.setAttribute('aria-label', 'Agrandir la photo');
    const open = () => {
      if (!dlg) build();
      show(i, false);
      dlg.showModal();
      document.documentElement.classList.add('m-lb-open');
    };
    f.addEventListener('pointerenter', () => warm(i), { once: true });
    f.addEventListener('touchstart', () => warm(i), { once: true, passive: true });
    f.addEventListener('click', open);
    f.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  });
})();
